import axios from 'axios'
import { useAppStore } from '@/store'
import { showFailToast } from 'vant'
import Spinner from '@/components/Spinner'

import { getApiUrl } from '@aomi/utils'
import { ENV } from '@/constant'
import { generateSign } from '../sign'
import { transformResponse } from '@/utils/fetch/util'
import handleHttpError from './handleHttpError'
const BASEURL = {
  base: {
    development: 'https://test-api.aomiapp.com',
    test: 'https://test-api.aomiapp.com',
    uat: 'https://uat-api.aomiapp.com',
    sit: 'https://gray-api.aomiapp.com',
    prod: 'https://api.aomiapp.com',
  },
}
const axiosInstance = axios.create({
  transformResponse,
  timeout: 50 * 1000,
  withCredentials: false,
  validateStatus: function (status) {
    return status >= 200 && status < 300
  },
})

export default async function fetch(
  url: string,
  option: AxiosConfig = { method: 'GET' },
  name = 'lifepay',
): Promise<Result> {
  const appStore = useAppStore()
  const { appId, token, sessionId, getChannel, deviceId, SDKKey, senceUserId, tempKey } = appStore
  const { params, method, isToastErr = true } = option

  let timestamp: number
  if (params) {
    // !!!如果参数上有时间戳用参数的时间戳 否则会出现请求头时间戳和参数时间不一致 导致支付密码低概率性通过
    timestamp = params.timestamp || new Date().getTime()
  } else {
    timestamp = new Date().getTime()
  }
  const requestHeaders: RequestHeader = {
    appId,
    channel: getChannel,
    requestTime: timestamp,
    sessionId,
    token,
  }

  // senceUserId不能传空值 否则在支付密码验签的时候会报支付密码错误
  if (senceUserId) requestHeaders.senceUserId = senceUserId
  if (deviceId) requestHeaders.deviceNo = deviceId

  const signParams = {
    ...requestHeaders,
    ...params,
  }
  // appId不参与验签，考虑目前澳觅项目兼容问题
  delete signParams.appId

  console.log('[默认的SDKKey] ', SDKKey)
  console.log('[临时的SDKKey-tempKey] ', tempKey)
  requestHeaders.sign = generateSign(method, signParams, tempKey || SDKKey)

  const headers = {
    ...requestHeaders,
    ...option.headers,
  }

  if (method?.toUpperCase() === 'POST') {
    headers['Content-Type'] = 'application/x-www-form-urlencoded'
  }
  let baseURL = getApiUrl('lifepay', ENV)
  if (name !== 'lifepay') {
    baseURL = BASEURL[name][ENV]
  }
  return new Promise((resolve, reject) => {
    axiosInstance
      .request({ baseURL, ...option, url, headers })
      .then((res) => {
        Spinner.close()

        const result = res.data

        if (result.resultCode === '200') {
          return resolve(result)
        }

        isToastErr && handleHttpError(result)

        reject(result)
      })
      .catch((e) => {
        console.log(e)
        const stringError = String(e)
        let netErrorType = 'neterror'
        if (stringError.match('timeout') || stringError.match('ERR_TIMED_OUT')) {
          netErrorType = 'timeout'
        } else if (stringError.match('exitSDK')) {
          netErrorType = 'exitSDK'
        }
        showFailToast(netErrorType)
        reject(Error(`${netErrorType}`))
      })
  })
}
